import React, { useRef } from 'react';
import ProjectListTableV2 from '@components/common/Table/ProjectListTableV2';
import Fab from "@mui/material/Fab";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const ProjectListV2 = () => {
  const scrollToTop = () => {
    const scrollableElement = document.querySelector('.Toolpad_DashboardLayout-main') || 
                             document.querySelector('main') || 
                             document.querySelector('.MuiBox-root[role="main"]');
    if (scrollableElement) {
      scrollableElement.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const scrollToBottom = () => {
    const scrollableElement = document.querySelector('.Toolpad_DashboardLayout-main') || 
                             document.querySelector('main') || 
                             document.querySelector('.MuiBox-root[role="main"]');
    if (scrollableElement) {
      scrollableElement.scrollTo({
        top: scrollableElement.scrollHeight,
        behavior: "smooth",
      });
    }
  };

  return (
    <React.Fragment>
      <ProjectListTableV2 />
      <div
        style={{
          position: "fixed",
          bottom: 16,
          right: 16,
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          zIndex: 1000,
        }}
      >
        <Fab color="primary" onClick={scrollToTop} size="medium">
          <KeyboardArrowUpIcon />
        </Fab>
        <Fab color="primary" onClick={scrollToBottom} size="medium">
          <KeyboardArrowDownIcon />
        </Fab>
      </div>
    </React.Fragment>
  );
};

export default ProjectListV2;
